(() => {
  const mobile = window.matchMedia('(max-width: 699px)');
  const selector = 'product-list[collection-mobile-layout] .product-card__media';
  let gesture = null;
  let blockedClick = null;

  function setIndex(media, index) {
    media.dataset.poSwipe = String(index);
    media.style.setProperty('--po-swipe-index', String(index));
  }

  function resetGesture() {
    if (!gesture) return;
    const { media, pointerId } = gesture;
    gesture = null;
    media.classList.remove('po-swipe-dragging');
    media.style.removeProperty('--po-swipe-drag');
    if (media.hasPointerCapture(pointerId)) media.releasePointerCapture(pointerId);
  }

  function initialize() {
    document.querySelectorAll(selector).forEach(media => {
      if (media.classList.contains('po-swipe-ready')) return;
      const primary = media.querySelector('.product-card__image--primary');
      const secondary = media.querySelector('.product-card__image--secondary');
      if (!primary || !secondary) return;
      media.classList.add('po-swipe-ready');
      setIndex(media, 0);
      const dots = document.createElement('span');
      dots.className = 'po-swipe-dots';
      dots.setAttribute('aria-hidden', 'true');
      dots.append(document.createElement('span'), document.createElement('span'));
      media.append(dots);
    });
  }

  document.addEventListener('pointerdown', event => {
    if (gesture) {
      resetGesture();
      return;
    }
    if (!mobile.matches || !event.isPrimary || event.button !== 0) return;
    const media = event.target.closest?.(selector);
    if (!media?.classList.contains('po-swipe-ready')) return;
    media.querySelector('.product-card__image--secondary').loading = 'eager';
    gesture = {
      media,
      pointerId: event.pointerId,
      startX: event.clientX,
      startY: event.clientY,
      dx: 0,
      index: Number(media.dataset.poSwipe),
      horizontal: false
    };
  });

  document.addEventListener('pointermove', event => {
    if (!gesture || event.pointerId !== gesture.pointerId) return;
    const dx = event.clientX - gesture.startX;
    const dy = event.clientY - gesture.startY;
    if (!gesture.horizontal) {
      if (Math.abs(dy) > 8 && Math.abs(dy) >= Math.abs(dx)) {
        resetGesture();
        return;
      }
      if (Math.abs(dx) < 10 || Math.abs(dx) < Math.abs(dy) * 1.25) return;
      gesture.horizontal = true;
      gesture.media.setPointerCapture(event.pointerId);
      gesture.media.classList.add('po-swipe-dragging');
    }
    gesture.dx = dx;
    const width = gesture.media.getBoundingClientRect().width;
    const outward = (gesture.index === 0 && dx > 0) || (gesture.index === 1 && dx < 0);
    const drag = Math.max(-width, Math.min(width, outward ? dx * 0.2 : dx));
    gesture.media.style.setProperty('--po-swipe-drag', `${drag}px`);
    if (event.cancelable) event.preventDefault();
  }, { passive: false });

  document.addEventListener('pointerup', event => {
    if (!gesture || event.pointerId !== gesture.pointerId) return;
    if (gesture.horizontal) {
      const { media, dx, index } = gesture;
      const threshold = Math.max(28, Math.min(45, media.getBoundingClientRect().width * 0.18));
      const next = Math.abs(dx) >= threshold ? Math.max(0, Math.min(1, index + (dx < 0 ? 1 : -1))) : index;
      setIndex(media, next);
      blockedClick = { media, until: performance.now() + 500 };
      if (event.cancelable) event.preventDefault();
    }
    resetGesture();
  });

  document.addEventListener('pointercancel', event => {
    if (gesture?.pointerId === event.pointerId) resetGesture();
  });

  document.addEventListener('lostpointercapture', event => {
    if (gesture?.pointerId === event.pointerId) resetGesture();
  });

  document.addEventListener('click', event => {
    if (!blockedClick || performance.now() > blockedClick.until || event.detail === 0) return;
    if (blockedClick.media.contains(event.target)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      blockedClick = null;
    }
  }, true);

  document.addEventListener('change', event => {
    const media = event.target.closest?.('product-card')?.querySelector('.po-swipe-ready');
    if (media) setIndex(media, 0);
  });

  mobile.addEventListener('change', () => {
    resetGesture();
    blockedClick = null;
    document.querySelectorAll('.po-swipe-ready').forEach(media => setIndex(media, 0));
  });

  initialize();
  new MutationObserver(initialize).observe(document.getElementById('main') || document.body, { childList: true, subtree: true });
})();
